import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Form,
  List,
  Tab,
  Card
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import tabsData from "../../../SmartBuildingFrontDesk/components/SmartBuildingFrontDeskList/smartBuilding.json";




function onChange(key) {
  // console.log(key);
}


const shapes = ['wrapped'];
// const onError=(e)=> {
//   logger.logError(e, 'error in file-viewer');
// }
const AnnouncementFrontDesk = (props) => {
  return (
    <>
    
      <div className="fusion-demo">
        {
          shapes.map(shape => (<div key={shape} className="fusion-demo-item">
            <Tab shape={shape} onChange={onChange}>
              {
                tabsData.map(tabsData => <Tab.Item title={tabsData.name} key={tabsData.key}>
                {tabsData.children.map((list,index)=>{
                  return(
                    <Card free style={{marginTop: "20px"}} key={index}>
                    <Card.Content >
                      <h1>{list.title}</h1>
                      <p>{list.content}</p>
                    </Card.Content>

                  </Card>
                  )
                 
                })}
                  
                </Tab.Item>)
              }
            </Tab>
          </div>))
        }
      </div>
     


    </>
  )




};

export default AnnouncementFrontDesk;
